var _path, _g, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3576,
    height: 1304,
    viewBox: "0 0 3576 1304",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1462 51.3675C1645.53 585.809 2480.83 635.263 2922.53 635.263H3524.35C3524.77 635.263 3525 635.566 3525 635.98V1303.29C3525 1303.7 3524.66 1303.7 3524.25 1303.7H2.24997C1.83576 1303.7 1.5 1303.36 1.5 1302.95V636.013C1.5 635.599 1.81782 635.263 2.23204 635.263C454.417 635.21 1277.16 585.521 1460.56 51.368C1460.79 50.6902 1461.77 50.6897 1462 51.3675Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.75 634.25C1072.09 634.25 1368.18 305.08 1461.38 53.75C1554.72 305.08 1851.28 634.25 2873.25 634.25H3523.88",
    stroke: "url(#paint0_linear_19_537)",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.37 68.75L1461.73 68.6179L1461.37 67.6844L1461.02 68.6181L1461.37 68.75ZM51.75 638.375C51.5429 638.375 51.375 638.543 51.375 638.75C51.375 638.957 51.5429 639.125 51.75 639.125V638.375ZM3501.37 639.125C3501.58 639.125 3501.75 638.957 3501.75 638.75C3501.75 638.543 3501.58 638.375 3501.37 638.375V639.125ZM2873.25 638.375C2362.3 638.375 2032.73 557.896 1819.25 446.442C1605.78 334.995 1508.36 192.568 1461.73 68.6179L1461.02 68.8821C1507.73 192.998 1605.26 335.571 1818.9 447.107C2032.53 558.637 2362.23 639.125 2873.25 639.125V638.375ZM51.75 639.125C561.954 639.125 891.129 558.637 1104.42 447.107C1317.72 335.571 1415.1 192.998 1461.73 68.8819L1461.02 68.6181C1414.46 192.568 1317.2 334.995 1104.07 446.442C890.927 557.896 561.885 638.375 51.75 638.375V639.125ZM2873.25 639.125H3501.37V638.375H2873.25V639.125Z",
    fill: "url(#paint1_linear_19_537)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1461.37 80L1461.59 79.9208L1461.37 79.3607L1461.16 79.9209L1461.37 80ZM51.75 641.525C51.6257 641.525 51.525 641.626 51.525 641.75C51.525 641.874 51.6257 641.975 51.75 641.975V641.525ZM3505.12 641.975C3505.25 641.975 3505.35 641.874 3505.35 641.75C3505.35 641.626 3505.25 641.525 3505.12 641.525V641.975ZM2873.25 641.525C2362.29 641.525 2032.69 563.101 1819.18 453.69C1605.68 344.284 1508.24 203.891 1461.59 79.9208L1461.16 80.0792C1507.85 204.151 1605.37 344.633 1818.97 454.091C2032.57 563.545 2362.25 641.975 2873.25 641.975V641.525ZM51.75 641.975C561.94 641.975 891.087 563.545 1104.35 454.091C1317.61 344.632 1414.97 204.151 1461.59 80.0791L1461.16 79.9209C1414.59 203.891 1317.3 344.284 1104.14 453.691C890.969 563.101 561.9 641.525 51.75 641.525V641.975ZM2873.25 641.975H3505.12V641.525H2873.25V641.975Z",
    fill: "url(#paint2_linear_19_537)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1464.63 178.18C1464.67 177.722 1465.34 177.722 1465.37 178.18L1485.94 422.003C1486.19 425.009 1486.98 427.947 1488.25 430.681L1560.37 585.268C1560.56 585.685 1559.98 586.019 1559.72 585.639L1472.42 458.746C1468.84 453.548 1461.16 453.548 1457.59 458.746L1370.29 585.639C1370.03 586.019 1369.44 585.685 1369.64 585.268L1441.75 430.681C1443.03 427.947 1443.81 425.009 1444.06 422.003L1464.63 178.18Z",
    fill: "url(#paint3_linear_19_537)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.52 417.403L1449.27 361.273C1449.36 360.184 1450.89 360.011 1451.22 361.052L1488.87 478.53C1489.22 479.625 1487.75 480.35 1487.1 479.404L1444.7 418.055C1444.57 417.865 1444.5 417.634 1444.52 417.403Z",
    fill: "url(#paint4_linear_19_537)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1425.82 558.762C1390.38 660.644 1336.82 800.424 1114.7 888.032",
    stroke: "url(#paint5_linear_19_537)",
    strokeWidth: 0.648169
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1328.06,
    y: 526.764,
    width: 11.717,
    height: 0.75,
    rx: 0.375,
    transform: "rotate(135 1328.06 526.764)",
    fill: "url(#paint6_linear_19_537)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.717,
    height: 0.834618,
    rx: 0.417309,
    transform: "matrix(0.70712 0.707093 0.70712 -0.707093 1606.21 529.014)",
    fill: "url(#paint7_linear_19_537)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.80413,
    height: 0.75,
    rx: 0.375,
    transform: "matrix(0.707124 -0.707089 -0.707124 -0.707089 1305.79 549.042)",
    fill: "url(#paint8_linear_19_537)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.68887,
    height: 0.75,
    rx: 0.375,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 1300.6 554.232)",
    fill: "url(#paint9_linear_19_537)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1628.49,
    y: 551.292,
    width: 6.80413,
    height: 0.834618,
    rx: 0.417309,
    transform: "rotate(-135 1628.49 551.292)",
    fill: "url(#paint10_linear_19_537)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1632.66,
    y: 555.457,
    width: 0.995459,
    height: 0.834618,
    rx: 0.417309,
    transform: "rotate(-135 1632.66 555.457)",
    fill: "url(#paint11_linear_19_537)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1595.87 518.61L1525.02 447.755C1515.9 438.643 1509.98 426.832 1508.13 414.081L1480.92 226.805",
    stroke: "url(#paint12_linear_19_537)",
    strokeWidth: 0.834618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.9 518.61L1406.75 447.755C1415.87 438.643 1421.79 426.832 1423.64 414.081L1450.85 226.805",
    stroke: "url(#paint13_linear_19_537)",
    strokeWidth: 0.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1411.94 348.832L1426.09 269.249",
    stroke: "url(#paint14_linear_19_537)",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1530.43 410.731L1519.82 347.065",
    stroke: "url(#paint15_linear_19_537)",
    strokeWidth: 0.648169,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1509.21 302.851L1505.68 278.092",
    stroke: "url(#paint16_linear_19_537)",
    strokeWidth: 0.648169,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1442.01 198.509L1443.78 187.897",
    stroke: "url(#paint17_linear_19_537)",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1488.75 525.5C1520.43 607.527 1605.42 753.008 1743.48 826.251",
    stroke: "url(#paint18_linear_19_537)",
    strokeWidth: 0.648169
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1370.31 829.854C1344 876.895 1312.29 912.008 1286.25 939.235",
    stroke: "url(#paint19_linear_19_537)",
    strokeWidth: 0.648169
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1578.78 456.757C1601.9 483.271 1610.55 491.664 1625.79 504.814",
    stroke: "url(#paint20_linear_19_537)",
    strokeWidth: 0.648169
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1633.5 832.25C1657.19 873.775 1720.75 947.422 1824 984.5",
    stroke: "url(#paint21_linear_19_537)",
    strokeWidth: 0.648169
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1502.5 78.7786C1560.75 213.5 1707.1 345.272 1828.67 407.151",
    stroke: "url(#paint22_linear_19_537)",
    strokeWidth: 0.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1414.1 78.7783C1366.5 214.25 1209.5 345.272 1087.93 407.151",
    stroke: "url(#paint23_linear_19_537)",
    strokeWidth: 0.75
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2385.29 582.121C2385.42 582.184 2385.54 582.273 2385.64 582.364C2385.74 582.466 2385.82 582.593 2385.89 582.729C2385.93 582.868 2385.99 583.014 2385.99 583.198C2386.01 583.377 2385.99 583.574 2385.95 583.796L2385.9 584.134C2385.72 585.206 2385.1 585.644 2384.01 585.467L2380.38 584.848C2380.38 584.848 2380.66 583.186 2380.95 581.528C2381.23 579.865 2381.52 578.207 2381.52 578.207L2384.95 578.788C2386.03 578.969 2386.47 579.603 2386.29 580.68L2386.26 580.807C2386.2 581.177 2386.1 581.472 2385.93 581.685C2385.78 581.905 2385.57 582.044 2385.29 582.121ZM2381.8 582.115L2381.47 584.074L2384.14 584.53C2384.4 584.574 2384.59 584.552 2384.72 584.442C2384.85 584.353 2384.94 584.175 2384.98 583.921L2385.07 583.404C2385.11 583.156 2385.08 582.959 2384.99 582.831C2384.91 582.698 2384.73 582.614 2384.47 582.565L2381.8 582.115ZM2382.28 579.301L2381.96 581.181L2384.51 581.623C2384.75 581.654 2384.92 581.613 2385.04 581.514C2385.15 581.418 2385.24 581.25 2385.28 581.002L2385.35 580.574C2385.39 580.32 2385.37 580.124 2385.28 579.986C2385.18 579.851 2385.01 579.763 2384.77 579.72L2382.28 579.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2387.88 579.289L2388.83 579.44C2388.83 579.44 2388.6 580.872 2388.36 582.287C2388.12 583.719 2387.89 585.145 2387.89 585.145L2391.69 585.761C2391.69 585.761 2391.93 584.34 2392.16 582.914C2392.39 581.497 2392.63 580.065 2392.63 580.065L2393.57 580.222C2393.57 580.222 2393.34 581.649 2393.11 583.07C2392.88 584.497 2392.65 585.924 2392.65 585.924C2392.62 586.055 2392.58 586.169 2392.51 586.285C2392.44 586.391 2392.36 586.479 2392.26 586.548C2392.16 586.624 2392.05 586.676 2391.92 586.7C2391.79 586.734 2391.67 586.743 2391.54 586.712L2387.73 586.09C2387.59 586.065 2387.48 586.026 2387.36 585.949C2387.26 585.89 2387.17 585.798 2387.1 585.699C2387.03 585.6 2386.98 585.488 2386.94 585.371C2386.92 585.239 2386.91 585.109 2386.93 584.977C2386.93 584.977 2387.17 583.557 2387.41 582.131C2387.64 580.709 2387.88 579.289 2387.88 579.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2395.94 580.607C2395.94 580.607 2395.68 582.267 2395.41 583.932C2395.15 585.592 2394.88 587.257 2394.88 587.257L2393.92 587.1C2393.92 587.1 2394.2 585.44 2394.46 583.775C2394.73 582.111 2395 580.456 2395 580.456L2395.94 580.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2398.32 580.983C2398.32 580.983 2398.1 582.405 2397.87 583.832C2397.64 585.26 2397.42 586.687 2397.42 586.687L2400.85 587.225L2400.69 588.171C2400.69 588.171 2399.6 588.005 2398.5 587.831C2397.4 587.654 2396.31 587.482 2396.31 587.482C2396.31 587.482 2396.58 585.822 2396.84 584.162C2397.11 582.492 2397.37 580.832 2397.37 580.832L2398.32 580.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400.87 581.388C2400.87 581.388 2402.21 581.591 2403.53 581.799C2404.87 582.003 2406.19 582.2 2406.19 582.2L2406.05 583.153L2403.86 582.824C2403.86 582.824 2403.64 584.253 2403.43 585.676C2403.21 587.098 2402.99 588.532 2402.99 588.532L2402.04 588.386C2402.04 588.386 2402.25 586.958 2402.47 585.53C2402.7 584.107 2402.92 582.674 2402.92 582.674L2400.73 582.34L2400.87 581.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2414.49 589.265C2414.46 589.397 2414.42 589.522 2414.36 589.634C2414.3 589.74 2414.21 589.827 2414.11 589.907C2414.01 589.982 2413.9 590.029 2413.77 590.065C2413.65 590.094 2413.52 590.102 2413.4 590.088L2409.57 589.518C2409.44 589.498 2409.32 589.464 2409.21 589.388C2409.11 589.333 2409.01 589.248 2408.94 589.149C2408.87 589.044 2408.8 588.93 2408.77 588.814C2408.75 588.682 2408.74 588.563 2408.76 588.425C2408.76 588.425 2408.94 587.24 2409.12 586.049C2409.29 584.864 2409.47 583.668 2409.47 583.668C2409.48 583.545 2409.53 583.422 2409.59 583.321C2409.66 583.204 2409.75 583.117 2409.85 583.042C2409.95 582.972 2410.05 582.913 2410.17 582.883C2410.3 582.849 2410.43 582.841 2410.56 582.861L2414.36 583.418C2414.5 583.437 2414.62 583.477 2414.71 583.552C2414.83 583.618 2414.91 583.698 2415 583.798C2415.07 583.897 2415.12 584.01 2415.15 584.132C2415.19 584.259 2415.19 584.383 2415.18 584.511C2415.18 584.511 2415 585.696 2414.83 586.888C2414.66 588.074 2414.49 589.265 2414.49 589.265ZM2410.42 583.813C2410.42 583.813 2410.24 585.004 2410.06 586.195C2409.89 587.38 2409.71 588.565 2409.71 588.565L2413.54 589.135C2413.54 589.135 2413.71 587.939 2413.88 586.753C2414.05 585.562 2414.22 584.365 2414.22 584.365L2410.42 583.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.75 590.569L2415.78 590.422C2415.78 590.422 2416.02 588.759 2416.26 587.091C2416.5 585.424 2416.74 583.761 2416.74 583.761L2417.7 583.897C2417.7 583.897 2418.51 585.329 2419.33 586.757C2420.14 588.195 2420.98 589.634 2420.98 589.634C2420.98 589.634 2421.16 588.336 2421.33 587.038C2421.52 585.751 2421.68 584.452 2421.68 584.452L2422.64 584.593C2422.64 584.593 2422.41 586.262 2422.18 587.925C2421.96 589.595 2421.72 591.258 2421.72 591.258L2420.77 591.133C2420.77 591.133 2419.93 589.694 2419.12 588.261C2418.3 586.828 2417.49 585.39 2417.49 585.39C2417.49 585.39 2417.3 586.687 2417.11 587.98C2416.93 589.272 2416.75 590.569 2416.75 590.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2429.6 585.534C2429.6 585.534 2430.01 587.284 2430.44 589.045C2430.87 590.796 2431.29 592.551 2431.29 592.551L2430.32 592.425L2429.95 590.804L2426.92 590.401L2426.13 591.864L2425.16 591.738C2425.16 591.738 2426.03 590.154 2426.9 588.565C2427.77 586.981 2428.64 585.403 2428.64 585.403L2429.6 585.534ZM2427.41 589.497L2429.7 589.804L2428.95 586.717L2427.41 589.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2433.11 592.787L2432.15 592.656C2432.15 592.656 2432.37 590.985 2432.58 589.315C2432.8 587.655 2433.01 585.985 2433.01 585.985L2433.97 586.105C2433.97 586.105 2434.8 587.528 2435.65 588.947C2436.49 590.372 2437.33 591.796 2437.33 591.796C2437.33 591.796 2437.49 590.502 2437.66 589.202C2437.82 587.914 2437.98 586.619 2437.98 586.619L2438.94 586.739C2438.94 586.739 2438.73 588.409 2438.51 590.08C2438.31 591.752 2438.1 593.424 2438.1 593.424L2437.14 593.292C2437.14 593.292 2436.3 591.873 2435.45 590.453C2434.62 589.029 2433.78 587.6 2433.78 587.6C2433.78 587.6 2433.61 588.899 2433.45 590.193C2433.27 591.487 2433.11 592.787 2433.11 592.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2443.06 593.061C2443.51 593.11 2443.87 593.036 2444.13 592.822C2444.4 592.614 2444.57 592.288 2444.62 591.843L2444.86 589.836C2444.89 589.618 2444.88 589.424 2444.83 589.236C2444.8 589.06 2444.72 588.901 2444.61 588.777C2444.51 588.642 2444.38 588.531 2444.21 588.448C2444.05 588.366 2443.86 588.308 2443.64 588.284L2441.19 587.982C2441.19 587.982 2441.05 589.177 2440.9 590.376C2440.76 591.57 2440.61 592.759 2440.61 592.759L2443.06 593.061ZM2439.53 593.594C2439.53 593.594 2439.74 591.923 2439.95 590.251C2440.15 588.584 2440.36 586.913 2440.36 586.913L2443.76 587.324C2444.11 587.368 2444.42 587.46 2444.7 587.614C2444.98 587.757 2445.2 587.942 2445.38 588.172C2445.56 588.4 2445.69 588.662 2445.76 588.965C2445.83 589.264 2445.86 589.594 2445.81 589.939L2445.58 591.951C2445.53 592.307 2445.44 592.631 2445.29 592.899C2445.15 593.179 2444.96 593.401 2444.73 593.586C2444.51 593.761 2444.24 593.893 2443.94 593.973C2443.63 594.038 2443.3 594.061 2442.95 594.017L2439.53 593.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2449.91 588.054C2449.91 588.054 2451.13 588.192 2452.34 588.339C2453.55 588.476 2454.78 588.608 2454.78 588.608L2454.67 589.57L2450.75 589.119L2450.54 591.031L2453.88 591.409L2453.77 592.376L2450.43 591.998L2450.09 594.855L2449.13 594.746C2449.13 594.746 2449.32 593.078 2449.52 591.4C2449.71 589.727 2449.91 588.054 2449.91 588.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.96 595.089C2460.93 595.227 2460.9 595.347 2460.84 595.464C2460.77 595.57 2460.69 595.663 2460.59 595.744C2460.51 595.815 2460.39 595.873 2460.26 595.907C2460.14 595.948 2460.01 595.961 2459.89 595.942L2456.05 595.527C2455.92 595.512 2455.8 595.483 2455.68 595.416C2455.58 595.357 2455.48 595.272 2455.4 595.181C2455.33 595.077 2455.27 594.974 2455.23 594.857C2455.19 594.729 2455.18 594.599 2455.19 594.471C2455.19 594.471 2455.33 593.271 2455.46 592.081C2455.6 590.885 2455.72 589.683 2455.72 589.683C2455.74 589.557 2455.78 589.442 2455.85 589.326C2455.91 589.214 2455.99 589.126 2456.08 589.044C2456.18 588.964 2456.29 588.906 2456.41 588.87C2456.53 588.83 2456.66 588.822 2456.79 588.831L2460.61 589.25C2460.73 589.258 2460.86 589.303 2460.97 589.369C2461.08 589.43 2461.18 589.505 2461.25 589.609C2461.32 589.698 2461.39 589.807 2461.43 589.935C2461.45 590.056 2461.48 590.177 2461.46 590.305C2461.46 590.305 2461.33 591.506 2461.2 592.702C2461.08 593.898 2460.96 595.089 2460.96 595.089ZM2456.68 589.788C2456.68 589.788 2456.55 590.984 2456.42 592.184C2456.29 593.38 2456.16 594.575 2456.16 594.575L2459.99 594.985C2459.99 594.985 2460.11 593.788 2460.25 592.593C2460.38 591.402 2460.51 590.201 2460.51 590.201L2456.68 589.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2468.04 592.441C2467.95 593.383 2467.48 593.871 2466.67 593.917L2467.66 596.751L2466.6 596.647L2465.63 593.848L2463.53 593.62L2463.25 596.305L2462.29 596.207C2462.29 596.207 2462.47 594.527 2462.63 592.856C2462.81 591.176 2462.99 589.508 2462.99 589.508L2466.66 589.888C2467.74 589.989 2468.23 590.59 2468.11 591.68L2468.04 592.441ZM2463.63 592.669L2466.29 592.945C2466.54 592.968 2466.74 592.924 2466.86 592.835C2466.98 592.736 2467.06 592.555 2467.08 592.3L2467.15 591.635C2467.18 591.375 2467.14 591.188 2467.04 591.064C2466.94 590.935 2466.75 590.861 2466.51 590.834L2463.85 590.557L2463.63 592.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2491.59 589.327C2491.59 589.327 2491.54 589.967 2491.46 590.932C2491.38 591.891 2491.27 593.175 2491.17 594.46C2491.07 595.739 2490.96 597.023 2490.88 597.982C2490.8 598.947 2490.75 599.592 2490.75 599.592L2488.66 599.42C2488.66 599.42 2488.71 598.775 2488.79 597.811C2488.87 596.851 2488.98 595.567 2489.09 594.283C2489.2 592.999 2489.3 591.714 2489.38 590.755C2489.47 589.791 2489.52 589.157 2489.52 589.157L2491.59 589.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2499.78 593.333C2499.78 593.333 2499.65 595.066 2499.52 596.8C2499.39 598.538 2499.26 600.272 2499.26 600.272C2499.18 601.349 2498.69 602.184 2497.97 602.73C2497.25 603.281 2496.29 603.538 2495.27 603.454C2494.27 603.378 2493.44 603.003 2492.84 602.427C2492.25 601.853 2491.9 601.073 2491.9 600.202L2493.98 600.389C2494 601.123 2494.63 601.508 2495.48 601.574C2496.29 601.629 2497.08 601.262 2497.17 600.132L2497.23 599.251C2496.68 599.557 2495.98 599.707 2495.21 599.64C2494.27 599.57 2493.44 599.115 2492.87 598.452C2492.3 597.798 2491.99 596.931 2492.06 596.046C2492.14 595.012 2492.59 594.179 2493.26 593.622C2493.93 593.07 2494.81 592.784 2495.74 592.858C2496.5 592.924 2497.17 593.179 2497.67 593.556L2497.7 593.189L2499.78 593.333ZM2497.39 597.263L2497.52 595.572C2497.14 594.913 2496.58 594.658 2495.99 594.611C2494.96 594.532 2494.21 595.166 2494.12 596.21C2494.06 596.988 2494.71 597.871 2495.72 597.959C2496.31 598.012 2496.93 597.847 2497.39 597.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2507.83 597.322C2507.76 598.39 2507.3 599.276 2506.6 599.878C2505.9 600.479 2504.95 600.79 2503.89 600.713C2502.82 600.636 2501.92 600.189 2501.31 599.498C2500.7 598.804 2500.37 597.859 2500.46 596.788C2500.54 595.726 2500.99 594.835 2501.7 594.228C2502.4 593.626 2503.35 593.31 2504.41 593.387C2505.47 593.458 2506.35 593.909 2506.97 594.61C2507.57 595.31 2507.91 596.255 2507.83 597.322ZM2505.82 597.174C2505.89 596.166 2505.29 595.311 2504.28 595.233C2503.26 595.16 2502.54 595.927 2502.46 596.935C2502.39 597.97 2502.99 598.788 2504.02 598.867C2505.04 598.918 2505.74 598.209 2505.82 597.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520.97 594.76C2520.97 594.76 2520.87 596.491 2520.77 598.223C2520.67 599.949 2520.57 601.675 2520.57 601.675L2518.52 601.56L2518.54 601.18C2517.99 601.487 2517.28 601.669 2516.52 601.624C2515.58 601.564 2514.74 601.103 2514.16 600.411C2513.58 599.714 2513.26 598.787 2513.32 597.788C2513.39 596.779 2513.83 595.896 2514.49 595.279C2515.15 594.662 2516.03 594.306 2516.98 594.371C2517.73 594.414 2518.4 594.675 2518.9 595.047L2518.93 594.663L2520.97 594.76ZM2518.64 599.17L2518.77 597.049C2518.38 596.415 2517.79 596.201 2517.2 596.164C2516.16 596.105 2515.36 596.901 2515.3 597.916C2515.24 598.905 2515.93 599.796 2516.96 599.854C2517.56 599.892 2518.17 599.759 2518.64 599.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2529.18 598.395L2528.99 602.149L2526.97 602.049L2527.16 598.542C2527.22 597.403 2526.7 596.793 2525.7 596.738C2525.18 596.704 2524.58 596.973 2524.06 597.524C2524.06 597.524 2524 598.604 2523.94 599.7C2523.88 600.785 2523.82 601.875 2523.82 601.875L2521.75 601.753C2521.75 601.753 2521.85 600.027 2521.95 598.307C2522.05 596.575 2522.15 594.844 2522.15 594.844L2524.21 594.969L2524.17 595.482C2524.75 595.06 2525.42 594.864 2526.19 594.904C2527.11 594.95 2527.87 595.318 2528.4 595.924C2528.94 596.53 2529.24 597.379 2529.18 598.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2487.7 599.317L2485.59 599.137C2485.59 599.137 2485.35 597.825 2485.11 596.504C2484.88 595.188 2484.65 593.878 2484.65 593.878C2484.65 593.878 2483.8 595.092 2482.94 596.317C2482.09 597.537 2481.23 598.751 2481.23 598.751L2478.85 598.536C2478.85 598.536 2479.18 598.067 2479.69 597.363C2480.18 596.647 2480.84 595.708 2481.5 594.769C2482.17 593.819 2482.82 592.874 2483.31 592.163C2483.81 591.459 2484.14 590.989 2484.14 590.989L2483.65 588.129C2483.65 588.129 2483.21 588.775 2482.54 589.73C2481.87 590.684 2480.99 591.96 2480.09 593.234C2479.2 594.503 2478.31 595.778 2477.63 596.732C2476.96 597.687 2476.51 598.326 2476.51 598.326L2474.14 598.091C2474.14 598.091 2474.71 597.292 2475.56 596.089C2476 595.485 2476.49 594.775 2477.03 594.015C2477.56 593.267 2478.12 592.462 2478.69 591.652C2479.26 590.848 2479.82 590.038 2480.35 589.283C2480.88 588.528 2481.37 587.818 2481.79 587.213C2482.64 586.003 2483.21 585.204 2483.21 585.204L2485.27 585.389L2485.87 588.853L2487.99 589.029L2486.33 591.457C2486.33 591.457 2486.66 593.423 2487.01 595.391C2487.35 597.359 2487.7 599.317 2487.7 599.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2537.78 592.272C2537.78 592.272 2537.76 592.914 2537.71 593.876C2537.66 594.839 2537.61 596.13 2537.55 597.414C2537.49 598.703 2537.44 599.988 2537.39 600.951C2537.35 601.914 2537.32 602.557 2537.32 602.557L2535.22 602.464L2535.24 602.079C2534.69 602.391 2534 602.579 2533.24 602.545C2532.28 602.496 2531.44 602.044 2530.85 601.357C2530.27 600.669 2529.93 599.741 2529.98 598.735C2530.04 597.735 2530.46 596.851 2531.11 596.223C2531.76 595.599 2532.64 595.242 2533.59 595.281C2534.35 595.325 2535.02 595.564 2535.53 595.943L2535.71 592.171L2537.78 592.272ZM2535.34 600.062L2535.44 597.938C2535.04 597.293 2534.43 597.092 2533.83 597.065C2532.78 597.016 2532.01 597.82 2531.96 598.836C2531.91 599.852 2532.6 600.739 2533.65 600.788C2534.25 600.816 2534.86 600.677 2535.34 600.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2513.05 596.043C2512.59 596.063 2511.53 596.056 2510.85 596.869L2510.56 601.071L2508.5 600.928C2508.5 600.928 2508.61 599.209 2508.74 597.485C2508.86 595.761 2508.97 594.031 2508.97 594.031L2511.02 594.178L2510.99 594.696C2511.49 594.32 2512.2 594.123 2513.16 594.28",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_537",
    x: 0,
    y: 0.782715,
    width: 3575.62,
    height: 688.217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.34902 0 0 0 0 0.305882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_537",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_537",
    x1: 1727.08,
    y1: 25.5652,
    x2: 1737.01,
    y2: -107.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_537",
    x1: 1196.09,
    y1: 37.9703,
    x2: 1186.4,
    y2: -93.5732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19_537",
    x1: 1196.09,
    y1: 41.0277,
    x2: 1186.4,
    y2: -90.5033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19_537",
    x1: 1612.83,
    y1: 750.224,
    x2: 1310.31,
    y2: 311.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19_537",
    x1: 1447.99,
    y1: 362.772,
    x2: 1489.85,
    y2: 480.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19_537",
    x1: 1425.82,
    y1: 570.083,
    x2: 1274.71,
    y2: 928.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251326,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19_537",
    x1: 1333.92,
    y1: 526.764,
    x2: 1333.92,
    y2: 527.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19_537",
    x1: 5.8585,
    y1: 0,
    x2: 5.8585,
    y2: 0.834618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19_537",
    x1: 3.40206,
    y1: 0,
    x2: 3.40206,
    y2: 0.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19_537",
    x1: 0.844437,
    y1: 0,
    x2: 0.844437,
    y2: 0.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_19_537",
    x1: 1631.89,
    y1: 551.292,
    x2: 1631.89,
    y2: 552.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_19_537",
    x1: 1633.16,
    y1: 555.457,
    x2: 1633.16,
    y2: 556.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_19_537",
    x1: 1556.08,
    y1: 226.805,
    x2: 1556.08,
    y2: 518.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_19_537",
    x1: 1403.1,
    y1: 233.879,
    x2: 1375.69,
    y2: 518.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_19_537",
    x1: 1385.42,
    y1: 233.879,
    x2: 1358.01,
    y2: 518.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_19_537",
    x1: 1556.96,
    y1: 295.778,
    x2: 1584.37,
    y2: 580.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_19_537",
    x1: 1542.81,
    y1: 221.5,
    x2: 1570.23,
    y2: 506.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_19_537",
    x1: 1411.95,
    y1: 113.62,
    x2: 1384.53,
    y2: 398.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_19_537",
    x1: 1488.75,
    y1: 525.5,
    x2: 1766.51,
    y2: 790.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_19_537",
    x1: 1369.69,
    y1: 829.666,
    x2: 1313.12,
    y2: 950.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48081,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_19_537",
    x1: 1578.33,
    y1: 457.497,
    x2: 1610.03,
    y2: 510.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337869,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_19_537",
    x1: 1633.5,
    y1: 832.25,
    x2: 1766.29,
    y2: 1019.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_19_537",
    x1: 1502.5,
    y1: 78.7784,
    x2: 1857.92,
    y2: 373.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_19_537",
    x1: 1414.1,
    y1: 78.7782,
    x2: 1058.68,
    y2: 373.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgL);
export default __webpack_public_path__ + "static/media/bg-l.770b7fe6bacde9329e2d1b5f55a0165e.svg";
export { ForwardRef as ReactComponent };